import { graphql } from 'msw'
import { advertisers } from './data'

function includesSearchExpression(value, searchExpression) {
  return value.toLowerCase().includes(searchExpression.toLowerCase())
}
function filterAdvertisersBySearchExpression(advertisers, searchExpression) {
  return advertisers.filter(({ cmsId, name }) => {
    return (
      includesSearchExpression(cmsId, searchExpression) ||
      includesSearchExpression(name, searchExpression)
    )
  })
}

const advertisersHandlers = [
  graphql.query('advertisers', (req, res, ctx) => {
    const { searchExpression, first, after } = req.variables

    const filteredAdvertisers = searchExpression
      ? filterAdvertisersBySearchExpression(advertisers, searchExpression)
      : advertisers

    const isFilteredAdvertisersEmpty = filteredAdvertisers.length === 0

    const pageSize = first
    const start = !after
      ? 0
      : filteredAdvertisers.findIndex((a) => a.cmsId === after) + 1
    const end = start + pageSize
    const paginatedAdvertisers = filteredAdvertisers.slice(start, end)
    const endCursor = isFilteredAdvertisersEmpty
      ? null
      : paginatedAdvertisers[paginatedAdvertisers.length - 1].cmsId
    const hasNextPage = end < filteredAdvertisers.length

    return res(
      ctx.data({
        advertisers: {
          pageInfo: {
            endCursor,
            hasNextPage,
          },
          nodes: paginatedAdvertisers,
        },
      })
    )
  }),
]

export default advertisersHandlers
